import { Helmet } from "react-helmet-async";
import styles from "./main.module.css";
import { motion } from "framer-motion";

import { NavLink } from "react-router-dom";
import Fon from "../../components/fon/fon";
import Typewriter from "../../components/writestring/writestring";

function MainPage() {
  return (
    <div className={styles.main}>
      <Helmet>
        <title>Lily-Dance Studio</title>
        <meta name="description" content="Dance and Vocal Classes with Lily" />
        <link rel="canonical" href="https://www.lily-d.com/" />
      </Helmet>
      <motion.div className={styles.main}>
        <Fon></Fon>
        <NavLink className={`${styles.stra} ${styles.str} `} to="/dance">
          <Typewriter
            strings="DANCE AND VOCAL CLASSES WITH LILY"
            color={"rgb(24,239,246)"}
          ></Typewriter>
        </NavLink>
        <NavLink className={`${styles.strw} ${styles.str} `} to="/dance">
          <Typewriter
            strings="Start as a beginner , LEVEL UP TO AUDITION"
            color={"rgb(245, 94, 200)"}
          ></Typewriter>
        </NavLink>

        <NavLink className={`${styles.strq} ${styles.str} `} to="/dance">
          <Typewriter
            strings="Make your dreams come true with Lily"
            color={"rgb(221, 135, 238)"}
          ></Typewriter>
        </NavLink>

        <NavLink className={`${styles.strt} ${styles.str} `} to="/dance">
          <Typewriter
            strings="DANCE AND VOCAL CLASSES WITH LILY"
            color={"rgb(24,239,246)"}
          ></Typewriter>
        </NavLink>
      </motion.div>
    </div>
  );
}

export default MainPage;
